import { Grid, Paper } from '@mui/material';

import { Link } from 'react-router-dom';

import './styles.scss';

interface Props {
  header: string;
  description: string;
  to: string;
  icon: string;
}

export function SettingsCard(props: Props) {
  return (
    <Link to={props.to}>
      <Paper className="settings-card" elevation={2}>
        <Grid container>
          <Grid className="settings-card__icon" item xs={12} display="flex" justifyContent="center">
            <span className="fa-stack fa-2x">
              <i className="fa fa-circle fa-stack-2x" style={{ color: 'lightgrey' }}></i>
              <i className={`fa ${props.icon} fa-stack-1x`}></i>
            </span>
          </Grid>
          <Grid className="settings-card__header" item xs={12}>
            {props.header}
          </Grid>
          <Grid className="settings-card__description" item xs={12}>
            {props.description}
          </Grid>
        </Grid>
      </Paper>
    </Link>
  );
}
